module.exports = __webpack_public_path__ + "static/img/coe-heavy-horse-white.bf78b8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-heavy-horse-white.svg
// module id = vNuy
// module chunks = 82